

export const getCustomerTypeServiceClasses = (values: string[] | undefined)=> {
  const serviceClasses = [];

  if(!values?.length) return undefined;

  if(values.includes("NSLT")){
    serviceClasses.push("Residential", "NonResidential");
  }
  if(values.includes("SLT")){
    serviceClasses.push("Industrial");
  }
  return serviceClasses
}
